



// import React, { useState, useEffect } from "react";




// import { useSelector } from "react-redux";
// import axios from "axios";
// import { toast } from "sonner";
// import { BsEye } from "react-icons/bs";
// import { CgMoreVertical } from "react-icons/cg";
// import { useNavigate } from "react-router-dom";
// import JobListing from "./JobListing";
// import EmployerUrgentStaffRequest from "./UrgentRequestForEmployer";

// const Dashboard = () => <div className="p-4">Welcome to your dashboard overview!</div>;
// const AllJobs = () => <div className="p-4"><EmployerUrgentStaffRequest /></div>;
// const CandidatePools = () => <div className="p-4">Candidate pools content here.</div>;
// const urgentStaff = () => <div className="p-4"><EmployerUrgentStaffRequest /></div>;
// const ProductsOnOffer = () => <div className="p-4">Products on offer content here.</div>;
// const Notifications = () => <div className="p-4">Notifications content here.</div>;

// const Dashboard1 = () => {
//   const [activeTab, setActiveTab] = useState("Dashboard");
//   const [stats, setStats] = useState({
//     onlineJobs: 0,
//     totalApplications: 0,
//     totalViews: 0,
//     draft: 0,
//     awaitingApproval: 0,
//     rejected: 0,
//     offline: 0,
//   });
//   const [jobStatusCounts, setJobStatusCounts] = useState({});
//   const [jobsByStatus, setJobsByStatus] = useState({});
//   const [selectedStatus, setSelectedStatus] = useState(null);
//   const [selectedJob, setSelectedJob] = useState(null);
//   const [applicationStats, setApplicationStats] = useState({
//     Applied: 0,
//     Shortlisted: 0,
//     Interviewed: 0,
//     Offer: 0,
//     Rejected: 0,
//     Accepted: 0,
//   });
//   const [recentJobs, setRecentJobs] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedJobType, setSelectedJobType] = useState("All"); // Changed to "All" for initial display

//   const { currentUser } = useSelector((state) => state.user);
//   const navigate = useNavigate();

//   // Calculate days left until expiration
//   const calculateDaysLeft = (expiryDate) => {
//     if (!expiryDate) return "N/A";
//     const today = new Date();
//     const expiry = new Date(expiryDate);
//     const diffTime = expiry - today;
//     const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
//     return diffDays >= 0 ? `${diffDays} day${diffDays !== 1 ? 's' : ''} left` : "Expired";
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         if (!currentUser || !currentUser._id) {
//           toast.error("No employer ID found. Please sign in again.");
//           return;
//         }

//         const employerId = currentUser._id;
//         const response = await axios.get(`${process.env.REACT_APP_API_URL}jobrecruiter/employer/${employerId}`, {
//           headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//         });

//         const data = response.data;
//         const newStats = {
//           onlineJobs: data.onlineJobs || 0,
//           totalApplications: data.totalApplications || 0,
//           totalViews: data.totalViews || 0, // Using API-provided totalViews as placeholder
//           draft: data.draft || 0,
//           awaitingApproval: data.awaitingApproval || 0,
//           rejected: data.rejected || 0,
//           offline: data.offline || 0,
//         };

//         const statusCounts = {
//           Draft: data.draft || 0,
//           "Awaiting Approval": data.awaitingApproval || 0,
//           Online: data.onlineJobs || 0,
//           Offline: data.offline || 0,
//           Rejected: data.rejected || 0,
//         };

//         // Fetch recent jobs
//         const jobsResponse = await axios.get(`${process.env.REACT_APP_API_URL}job/employers/${employerId}/jobs`, {
//           headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//         });
//         const jobs = jobsResponse.data.data || [];
//         const sortedJobs = jobs
//           .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
//           .slice(0, 3); // Get 3 most recent jobs
//         // Calculate total views client-side as fallback
//         const calculatedTotalViews = jobs.reduce((sum, job) => sum + (job.uniqueViewers || 0), 0);
//         setRecentJobs(sortedJobs);
//         setStats({ ...newStats, totalViews: newStats.totalViews || calculatedTotalViews });
//         setJobStatusCounts(statusCounts);
//         setJobsByStatus({
//           Draft: jobs.filter(job => job.status[0]?.value === "Draft"),
//           "Awaiting Approval": jobs.filter(job => job.status[0]?.value === "Awaiting Approval"),
//           Online: jobs.filter(job => job.status[0]?.value === "Online"),
//           Offline: jobs.filter(job => job.status[0]?.value === "Offline"),
//           Rejected: jobs.filter(job => job.status[0]?.value === "Rejected"),
//         });
//       } catch (error) {
//         console.error("Error fetching data:", error);
//         toast.error("Failed to load dashboard data");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [currentUser]);

//   const fetchApplicationStats = async (jobId) => {
//     try {
//       const response = await axios.get(`${process.env.REACT_APP_API_URL}application/getApplicationByJobId/${jobId}`, {
//         headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//       });
//       const applications = response.data.data || [];
//       const stats = {
//         Applied: 0,
//         Shortlisted: 0,
//         Interviewed: 0,
//         Offer: 0,
//         Rejected: 0,
//         Accepted: 0,
//       };
//       applications.forEach((app) => {
//         if (stats[app.status]) stats[app.status]++;
//       });
//       setApplicationStats(stats);
//     } catch (error) {
//       console.error("Error fetching application stats:", error);
//       toast.error("Failed to load application stats");
//     }
//   };

//   const handleJobTypeChange = (jobType) => {
//     setSelectedJobType(jobType);
//   };

//   const renderContent = () => {
//     switch (activeTab) {
//       case "Dashboard": return <Dashboard />;
//       case "Candidate Pools": return <CandidatePools />;
//       case "urgent staff": return <urgentStaff />;
//       case "Products on Offer": return <ProductsOnOffer />;
//       case "Notifications": return <Notifications />;
//       default: return <Dashboard />;
//     }
//   };

//   // Filter recent jobs based on selected job type
//   const filteredRecentJobs = selectedJobType === "All"
//     ? recentJobs
//     : recentJobs.filter(job => job.type === selectedJobType);

//   return (
//     <div className="min-h-screen flex">
//       {/* Sidebar Dropdown */}
//       <div className="w-64 bg-gray-800 text-white p-4">
//         <h3 className="text-lg font-semibold mb-4">Job Status Overview</h3>
//         <div className="space-y-2">
//           {Object.entries(jobStatusCounts).map(([status, count]) => (
//             <button
//               key={status}
//               onClick={() => setSelectedStatus(status)}
//               className="w-full text-left p-2 hover:bg-gray-700 rounded"
//             >
//               {status}: {count}
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="flex-1">
//         <nav className="bg-orange-600 text-white p-4 flex justify-between items-center">
//           <div className="flex space-x-4">
//             <button onClick={() => setActiveTab("Dashboard")} className="hover:underline">Dashboard</button>
//             <button onClick={() => setActiveTab("Candidate Pools")} className="hover:underline">Candidate Pools</button>
//             <button onClick={() => setActiveTab("urgent staff")} className="hover:underline">Request for urgent staff</button>
//             <button onClick={() => setActiveTab("Products on Offer")} className="hover:underline">Products on Offer</button>
//             <button onClick={() => setActiveTab("Notifications")} className="hover:underline">Notifications</button>
//           </div>
//         </nav>

//         <div className="container mx-auto p-4">
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
//             <div className="bg-white p-4 rounded shadow">
//               <h2 className="text-lg font-semibold">Online Jobs</h2>
//               <p className="text-2xl">{stats.onlineJobs}</p>
//               <p className="text-gray-500">06 May 2025 - 06 Aug 2025</p>
//               <p className="text-green-500">▼ 52%</p>
//             </div>
//             <div className="bg-white p-4 rounded shadow">
//               <h2 className="text-lg font-semibold">Total Applications</h2>
//               <p className="text-2xl">{stats.totalApplications}</p>
//               <p className="text-gray-500">06 May 2025 - 06 Aug 2025</p>
//               <p className="text-red-500">▼ 44%</p>
//             </div>
//             <div className="bg-white p-4 rounded shadow">
//               <h2 className="text-lg font-semibold">Total Views</h2>
//               <p className="text-2xl">{stats.totalViews}</p>
//               <p className="text-gray-500">06 May 2025 - 06 Aug 2025</p>
//               <p className="text-red-500">▼ 87%</p>
//             </div>
//           </div>
//           <div className="bg-white p-4 rounded shadow">
//             <h2 className="text-lg font-semibold">General Overview</h2>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <div>
//                 <h3 className="text-md font-medium">Filter by Job Type</h3>
//                 <div className="space-y-2">
//                   <label className="flex items-center">
//                     <input
//                       type="radio"
//                       name="jobType"
//                       className="mr-2"
//                       checked={selectedJobType === "All"}
//                       onChange={() => handleJobTypeChange("All")}
//                     />
//                     All Jobs
//                   </label>
//                   <label className="flex items-center">
//                     <input
//                       type="radio"
//                       name="jobType"
//                       className="mr-2"
//                       checked={selectedJobType === "Basic"}
//                       onChange={() => handleJobTypeChange("Basic")}
//                     />
//                     Basic Job
//                   </label>
//                   <label className="flex items-center">
//                     <input
//                       type="radio"
//                       name="jobType"
//                       className="mr-2"
//                       checked={selectedJobType === "Standard"}
//                       onChange={() => handleJobTypeChange("Standard")}
//                     />
//                     Standard Job
//                   </label>
//                   <label className="flex items-center">
//                     <input
//                       type="radio"
//                       name="jobType"
//                       className="mr-2"
//                       checked={selectedJobType === "Premium"}
//                       onChange={() => handleJobTypeChange("Premium")}
//                     />
//                     Premium
//                   </label>
//                 </div>
//               </div>
//               <div>
//                 <h3 className="text-md font-medium">Recent Activities</h3>
//                 {loading ? (
//                   <p>Loading recent jobs...</p>
//                 ) : (
//                   <ul className="list-disc pl-5">
//                     {filteredRecentJobs.length > 0 ? (
//                       filteredRecentJobs.map((job) => (
//                         <li
//                           key={job.id}
//                           className="cursor-pointer text-blue-500 hover:underline"
//                           onClick={() => {
//                             setSelectedJob(job);
//                             fetchApplicationStats(job.id);
//                           }}
//                         >
//                           {job.title} ({job.type}) - Expires: {job.expires} ({calculateDaysLeft(job.expires)})
//                         </li>
//                       ))
//                     ) : (
//                       <li>No recent jobs for {selectedJobType}</li>
//                     )}
//                   </ul>
//                 )}
//               </div>
//             </div>
//           </div>
//           {renderContent()}
//         </div>
//       </div>

//       {/* Modal for Job Status */}
//       {selectedStatus && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-11/12 md:w-3/4 lg:w-1/2 max-h-[80vh] overflow-y-auto">
//             <h2 className="text-xl font-bold mb-4">Jobs with Status: {selectedStatus}</h2>
//             <div className="space-y-4">
//               {jobsByStatus[selectedStatus]?.length > 0 ? (
//                 jobsByStatus[selectedStatus].map((job) => (
//                   <div key={job.id} className="p-4 border rounded">
//                     <h3 className="font-semibold">{job.title || "Untitled"}</h3>
//                     <p>Employer: {job.employer?.companyName || "Unknown"}</p>
//                     <p>Location: {`${job.city}, ${job.state}`}</p>
//                     <p>Views: {job.uniqueViewers || 0}</p>
//                     <p>Type: {job.type}</p>
//                     <p>Expires: {job.expires} ({calculateDaysLeft(job.expires)})</p>
//                   </div>
//                 ))
//               ) : (
//                 <p>No jobs found for this status.</p>
//               )}
//             </div>
//             <button
//               className="mt-4 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
//               onClick={() => setSelectedStatus(null)}
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Modal for Application Chart */}
//       {selectedJob && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-11/12 md:w-3/4 lg:w-1/2 max-h-[80vh] overflow-y-auto">
//             <h2 className="text-xl font-bold mb-4">Application Stats for: {selectedJob.title}</h2>
//             <canvas id="applicationChart" width="400" height="200"></canvas>
//             <button
//               className="mt-4 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
//               onClick={() => setSelectedJob(null)}
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Dashboard1;




import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { toast } from "sonner";
import { BsEye } from "react-icons/bs";
import { CgMoreVertical } from "react-icons/cg";
import { useNavigate } from "react-router-dom";
import JobListing from "./JobListing";
import EmployerUrgentStaffRequest from "./UrgentRequestForEmployer";

const Dashboard = () => <div className="p-4">Welcome to your dashboard overview!</div>;
const AllJobs = () => <div className="p-4"><EmployerUrgentStaffRequest /></div>;
const CandidatePools = () => <div className="p-4">Candidate pools content here.</div>;
const UrgentStaff = () => <div className="p-4"><EmployerUrgentStaffRequest /></div>; // Renamed and capitalized
const ProductsOnOffer = () => <div className="p-4">Products on offer content here.</div>;
const Notifications = () => <div className="p-4">Notifications content here.</div>;

const Dashboard1 = () => {
  const [activeTab, setActiveTab] = useState("Dashboard");
  const [stats, setStats] = useState({
    onlineJobs: 0,
    totalApplications: 0,
    totalViews: 0,
    draft: 0,
    awaitingApproval: 0,
    rejected: 0,
    offline: 0,
  });
  const [jobStatusCounts, setJobStatusCounts] = useState({});
  const [jobsByStatus, setJobsByStatus] = useState({});
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [applicationStats, setApplicationStats] = useState({
    Applied: 0,
    Shortlisted: 0,
    Interviewed: 0,
    Offer: 0,
    Rejected: 0,
    Accepted: 0,
  });
  const [recentJobs, setRecentJobs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedJobType, setSelectedJobType] = useState("All");

  const { currentUser } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const calculateDaysLeft = (expiryDate) => {
    if (!expiryDate) return "N/A";
    const today = new Date();
    const expiry = new Date(expiryDate);
    const diffTime = expiry - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays >= 0 ? `${diffDays} day${diffDays !== 1 ? "s" : ""} left` : "Expired";
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        if (!currentUser || !currentUser._id) {
          toast.error("No employer ID found. Please sign in again.");
          return;
        }

        const employerId = currentUser._id;
        const response = await axios.get(`${process.env.REACT_APP_API_URL}jobrecruiter/employer/${employerId}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });

        const data = response.data;
        const newStats = {
          onlineJobs: data.onlineJobs || 0,
          totalApplications: data.totalApplications || 0,
          totalViews: data.totalViews || 0,
          draft: data.draft || 0,
          awaitingApproval: data.awaitingApproval || 0,
          rejected: data.rejected || 0,
          offline: data.offline || 0,
        };

        const statusCounts = {
          Draft: data.draft || 0,
          "Awaiting Approval": data.awaitingApproval || 0,
          Online: data.onlineJobs || 0,
          Offline: data.offline || 0,
          Rejected: data.rejected || 0,
        };

        const jobsResponse = await axios.get(`${process.env.REACT_APP_API_URL}job/employers/${employerId}/jobs`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        const jobs = jobsResponse.data.data || [];
        const sortedJobs = jobs
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          .slice(0, 3);
        const calculatedTotalViews = jobs.reduce((sum, job) => sum + (job.uniqueViewers || 0), 0);
        setRecentJobs(sortedJobs);
        setStats({ ...newStats, totalViews: newStats.totalViews || calculatedTotalViews });
        setJobStatusCounts(statusCounts);
        setJobsByStatus({
          Draft: jobs.filter((job) => job.status[0]?.value === "Draft"),
          "Awaiting Approval": jobs.filter((job) => job.status[0]?.value === "Awaiting Approval"),
          Online: jobs.filter((job) => job.status[0]?.value === "Online"),
          Offline: jobs.filter((job) => job.status[0]?.value === "Offline"),
          Rejected: jobs.filter((job) => job.status[0]?.value === "Rejected"),
        });
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Failed to load dashboard data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [currentUser]);

  const fetchApplicationStats = async (jobId) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}application/getApplicationByJobId/${jobId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      const applications = response.data.data || [];
      const stats = {
        Applied: 0,
        Shortlisted: 0,
        Interviewed: 0,
        Offer: 0,
        Rejected: 0,
        Accepted: 0,
      };
      applications.forEach((app) => {
        if (stats[app.status]) stats[app.status]++;
      });
      setApplicationStats(stats);
    } catch (error) {
      console.error("Error fetching application stats:", error);
      toast.error("Failed to load application stats");
    }
  };

  const handleJobTypeChange = (jobType) => {
    setSelectedJobType(jobType);
  };

  const renderContent = () => {
    switch (activeTab) {
      case "Dashboard":
        return <Dashboard />;
      case "Candidate Pools":
        return <CandidatePools />;
      case "urgentStaff": // Changed from "urgent staff" to "urgentStaff"
        return <UrgentStaff />;
      case "Products on Offer":
        return <ProductsOnOffer />;
      case "Notifications":
        return <Notifications />;
      default:
        return <Dashboard />;
    }
  };

  const filteredRecentJobs = selectedJobType === "All"
    ? recentJobs
    : recentJobs.filter((job) => job.type === selectedJobType);

  return (
    <div className="min-h-screen flex">
      <div className="w-64 bg-gray-800 text-white p-4">
        <h3 className="text-lg font-semibold mb-4">Job Status Overview</h3>
        <div className="space-y-2">
          {Object.entries(jobStatusCounts).map(([status, count]) => (
            <button
              key={status}
              onClick={() => setSelectedStatus(status)}
              className="w-full text-left p-2 hover:bg-gray-700 rounded"
            >
              {status}: {count}
            </button>
          ))}
        </div>
      </div>

      <div className="flex-1">
        <nav className="bg-green-600 text-white p-4 flex justify-between items-center">
          <div className="flex space-x-4">
            <button onClick={() => setActiveTab("Dashboard")} className="hover:underline">
              Dashboard
            </button>
            <button onClick={() => setActiveTab("Candidate Pools")} className="hover:underline">
              Candidate Pools
            </button>
            <button onClick={() => setActiveTab("urgentStaff")} className="hover:underline"> 
              Request for urgent staff
            </button>
            <button onClick={() => setActiveTab("Products on Offer")} className="hover:underline">
              Products on Offer
            </button>
            <button onClick={() => setActiveTab("Notifications")} className="hover:underline">
              Notifications
            </button>
          </div>
        </nav>

        <div className="container mx-auto p-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <div className="bg-white p-4 rounded shadow">
              <h2 className="text-lg font-semibold">Online Jobs</h2>
              <p className="text-2xl">{stats.onlineJobs}</p>
              <p className="text-gray-500">06 May 2025 - 06 Aug 2025</p>
              <p className="text-green-500">▼ 52%</p>
            </div>
            <div className="bg-white p-4 rounded shadow">
              <h2 className="text-lg font-semibold">Total Applications</h2>
              <p className="text-2xl">{stats.totalApplications}</p>
              <p className="text-gray-500">06 May 2025 - 06 Aug 2025</p>
              <p className="text-red-500">▼ 44%</p>
            </div>
            <div className="bg-white p-4 rounded shadow">
              <h2 className="text-lg font-semibold">Total Views</h2>
              {/* <p className="text-2xl">  5</p> */}
              <p className="text-2xl">{stats.totalViews} </p>
              <p className="text-gray-500">06 May 2025 - 06 Aug 2025</p>
              <p className="text-red-500">▼ 87%</p>
            </div>
          </div>
          <div className="bg-white p-4 rounded shadow">
            <h2 className="text-lg font-semibold">General Overview</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <h3 className="text-md font-medium">Filter by Job Type</h3>
                <div className="space-y-2">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="jobType"
                      className="mr-2"
                      checked={selectedJobType === "All"}
                      onChange={() => handleJobTypeChange("All")}
                    />
                    All Jobs
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="jobType"
                      className="mr-2"
                      checked={selectedJobType === "Basic"}
                      onChange={() => handleJobTypeChange("Basic")}
                    />
                    Basic Job
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="jobType"
                      className="mr-2"
                      checked={selectedJobType === "Standard"}
                      onChange={() => handleJobTypeChange("Standard")}
                    />
                    Standard Job
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="jobType"
                      className="mr-2"
                      checked={selectedJobType === "Premium"}
                      onChange={() => handleJobTypeChange("Premium")}
                    />
                    Premium
                  </label>
                </div>
              </div>
              <div>
                <h3 className="text-md font-medium">Recent Activities</h3>
                {loading ? (
                  <p>Loading recent jobs...</p>
                ) : (
                  <ul className="list-disc pl-5">
                    {filteredRecentJobs.length > 0 ? (
                      filteredRecentJobs.map((job) => (
                        <li
                          key={job.id}
                          className="cursor-pointer text-blue-500 hover:underline"
                          onClick={() => {
                            setSelectedJob(job);
                            fetchApplicationStats(job.id);
                          }}
                        >
                          {job.title} ({job.type}) - Expires: {job.expires} ({calculateDaysLeft(job.expires)})
                        </li>
                      ))
                    ) : (
                      <li>No recent jobs for {selectedJobType}</li>
                    )}
                  </ul>
                )}
              </div>
            </div>
          </div>
          {renderContent()}
        </div>
      </div>

      {selectedStatus && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-11/12 md:w-3/4 lg:w-1/2 max-h-[80vh] overflow-y-auto">
            <h2 className="text-xl font-bold mb-4">Jobs with Status: {selectedStatus}</h2>
            <div className="space-y-4">
              {jobsByStatus[selectedStatus]?.length > 0 ? (
                jobsByStatus[selectedStatus].map((job) => (
                  <div key={job.id} className="p-4 border rounded">
                    <h3 className="font-semibold">{job.title || "Untitled"}</h3>
                    <p>Employer: {job.employer?.companyName || "Unknown"}</p>
                    <p>Location: {`${job.city}, ${job.state}`}</p>
                    <p>Views: {job.uniqueViewers || 0}</p>
                    <p>Type: {job.type}</p>
                    <p>Expires: {job.expires} ({calculateDaysLeft(job.expires)})</p>
                  </div>
                ))
              ) : (
                <p>No jobs found for this status.</p>
              )}
            </div>
            <button
              className="mt-4 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
              onClick={() => setSelectedStatus(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {selectedJob && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-11/12 md:w-3/4 lg:w-1/2 max-h-[80vh] overflow-y-auto">
            <h2 className="text-xl font-bold mb-4">Application Stats for: {selectedJob.title}</h2>
            <canvas id="applicationChart" width="400" height="200"></canvas>
            <button
              className="mt-4 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
              onClick={() => setSelectedJob(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard1;